import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import OneLevelList from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/OneLevelList/OneLevelList';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

const OneLevelListContainer = (props) => {
  const { getFiltersByFilterName } = useFiltersContext();
  const { filterName } = props;

  return (
    <OneLevelList
      { ...props }
      filterName={ filterName }
      filters={ getFiltersByFilterName(TRACE_STORE_NAME, filterName) }
    />
  );
};

export default OneLevelListContainer;
